const mutations = {
  setEvaluacionActiva (state: any, data: any) {
    state.reviewsAnswerId = data.reviewsAnswerId
    state.preguntas = data.preguntas
    state.tiempoDisponible = data.tiempoDisponible
    state.evaluacionActiva = true
  },
  setResultado (state: any, resultado: any) {
    state.resultado = resultado
    state.evaluacionActiva = false
  },
  limpiarEvaluacion (state: any) {
    state.reviewsAnswerId = null
    state.preguntas = []
    state.tiempoDisponible = 0
    state.resultado = null
    state.evaluacionActiva = false
  }
}

export default mutations
